import { render, staticRenderFns } from "./templateHeader.vue?vue&type=template&id=a11c7670&scoped=true"
import script from "./templateHeader.vue?vue&type=script&lang=js"
export * from "./templateHeader.vue?vue&type=script&lang=js"
import style0 from "./templateHeader.vue?vue&type=style&index=0&id=a11c7670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11c7670",
  null
  
)

export default component.exports